import Marquee from "react-fast-marquee";
import { MARQUEE_ITEMS } from "@/lib/data";

export default function BrandMarquee({ dark = false }) {
  const bg = dark ? "bg-blue" : "bg-blue-deep";
  const text = dark ? "text-cream" : "text-cream";
  return (
    <div data-testid="brand-marquee" className={`${bg} py-6 border-y border-amber/20 overflow-hidden`}>
      <Marquee speed={38} gradient={false} autoFill>
        {MARQUEE_ITEMS.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className={`font-serif font-bold italic text-2xl md:text-3xl ${text} px-8`}>{item}</span>
            <span className="text-amber text-xl">✦</span>
          </div>
        ))}
      </Marquee>
    </div>
  );
}
